import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from 'utils/utils'
import withStyle, {
  StyledLineContainer,
  StyledBgLine,
  StyledLine,
} from './PercentCompleteLine.style.js'

const PercentCompleteLine = ({
  className,
  count,
  total,
  label,
  maxBarWidth,
}) => (
  <div className={classNames(className)}>
    <span>
      {label}: {count}
    </span>
    <StyledLineContainer maxBarWidth={maxBarWidth}>
      <StyledBgLine />
      <StyledLine proportion={count / total} />
    </StyledLineContainer>
  </div>
)

PercentCompleteLine.propTypes = {
  /** Make sure to comment */
  /** Classname */
  className: PropTypes.string,
  /** The counted number of items tracked */
  count: PropTypes.number,
  /** The total (100%) of items that can exist in the given context */
  total: PropTypes.number,
  /** Label indicating type of item counted */
  label: PropTypes.string,
  /** maximum with of the bar */
  maxBarWidth: PropTypes.number,
}

export default withStyle(PercentCompleteLine)
